import { render, staticRenderFns } from "./Clicksign.vue?vue&type=template&id=a7cd4670&scoped=true&"
import script from "./Clicksign.vue?vue&type=script&lang=js&"
export * from "./Clicksign.vue?vue&type=script&lang=js&"
import style0 from "./Clicksign.vue?vue&type=style&index=0&id=a7cd4670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7cd4670",
  null
  
)

export default component.exports